// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__39-Ir","label":"Labeled_label__1P3Pd","divider":"Labeled_divider__3jQpn"};